// Main entry — the production View. (No Container: Section is a pure
// View.) Sim wrappers live under ./sim and are never imported here, so a
// production import of Section can't pull in fixtures.
export { Section } from "./Section";
export type { SectionProps } from "./Section";
